import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { SearchBar } from "../../../components";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useGroups } from "../hooks";
import { cleanObject } from "../../../helpers/clean-object";

interface ISearchForm {
  search?: string;
}

export const Groups: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const form = useForm<ISearchForm>({
    mode: "all",
    defaultValues: {
      search: searchParams.get("search") ?? "",
    },
  });

  const onSubmit = () => {
    const values = form.getValues();
    navigate({
      pathname: "/groups",
      search: `?${createSearchParams(cleanObject(values))}`,
    });
  };

  const search = searchParams.get("search");
  const where: any = {};
  if (search) where.search = search;

  const { data, loading } = useGroups({ where });

  return (
    <>
      <Header
        title="Groupes"
        subtitle="Liste des groupes de clients"
        buttons={[
          {
            actionText: "Nouveau groupe",
            bgColor: "indigo",
            textColor: "white",
            link: `/group/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <SearchBar form={form} onSubmit={onSubmit} placeholder="Rechercher un groupe..." />

        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.groups?.results?.length ? (
            <EmptyList text="Aucun groupe" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Nom</TableCell>
                  <TableCell header>Siren</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.groups?.results?.map((group) => (
                  <TableRow
                    key={`group-${group.id}`}
                    onClick={() => navigate(`/group/${group.id}`)}
                  >
                    <TableCell>{group.name}</TableCell>
                    <TableCell>{group.siren ?? "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
